import { INVALID_URL_MESSAGE } from "./constants";

const URL_REGEX = /^https?:\/\/(([\w.:-]+\/)+[\w.:-]*|[\w.:-]+)$/;

export const attachSlash = url => {
  if (!url) return;

  return url.endsWith("/") ? url : `${url}/`;
};

export const validateUrl = (url, name) => {
  const isValid = !!url && URL_REGEX.test(url);

  if (!isValid) {
    throw new Error(`${name} ${INVALID_URL_MESSAGE}`);
  }
};
